import {
  FAV_SAVE_STARTED, FAV_SAVE_DISPLAY, UPDATE_MEMBER_FAVOURITE_LIST,
  HIDE_FAVOURITE_MODAL, FAV_SAVE_COMPLETE, ADD_ITEM_TO_FAVOURITES, FAV_INIT_MEMBER
} from '../actions/actionTypes';

export const initialState = {
  displayModal: false,
  isLoading: false,
  isError: false,
  memberData: {
    listId: '',
    listName: '',
    // memberId: window.THDCustomer?.default?.svocID || '',
    memberId: '',
    isLoggedIn: false,
  },
  isFavoriteSaved: false,
};
export default (state = initialState, action) => {
  switch (action.type) {
  case FAV_SAVE_STARTED:
    return {
      ...state,
      displayModal: true,
      isError: false,
      isLoading: true,
      isFavoriteSaved: false,
    };
  case FAV_SAVE_DISPLAY:
    return {
      ...state,
      displayModal: true,
      isError: false,
      isLoading: true,
    };
  case UPDATE_MEMBER_FAVOURITE_LIST:
    return {
      ...state,
      memberData: { ...state.memberData, listId: action.listId, listName: action.listName },
      isLoading: false,
    };
  case HIDE_FAVOURITE_MODAL:
    return {
      ...state,
      displayModal: false,
    };
  case ADD_ITEM_TO_FAVOURITES:
    return {
      ...state,
      isLoading: true,
    };
  case FAV_SAVE_COMPLETE:
    return {
      ...state,
      isFavoriteSaved: true,
      isLoading: false,
    };
  case FAV_INIT_MEMBER:
    return {
      ...state,
      memberData: {
        ...state.memberData,
        memberId: window.THDCustomer?.default?.svocID || '',
        isLoggedIn: window.THDCustomer?.default?.isLoggedIn || false,
      },
    };
  default:
    return state;
  }
};
